import Box from "@@/elements/Box";
import SvgFile from "@@/elements/Icons/icons/File";
import Typography from "@@/elements/Typography";
import { LinkData } from "@@/models/linkdata";
import TextButtonIcon from "../Button/TextButtonIcon";
import styles from "./index.module.scss";

export type FileProps = {
  link: LinkData;
  type?: string;
};

type DocumentItemProps = {
  file: FileProps;
};

export const DocumentItem = ({ file }: DocumentItemProps) => {
  return (
    <Box
      component="li"
      br={1}
      className={styles.document_item}>
      <TextButtonIcon
        dense
        iconTop
        link={file.link}
        label={file.link.text}> <SvgFile/> </TextButtonIcon>
      <Typography
        color="PrimaryGrey"
        uppercase
        ml={7}
        variant="label">{file.type}</Typography>
    </Box>
  );
};

